import styled, { keyframes } from 'styled-components';

// Layout/kart iskeleti leave-dashboard/expense-dashboard'dan KOPYALANDI (brief:
// "DashboardCard.js'i kendi klasörüne kopyala... üçüncü kopya kabul edilebilir").
// Marka renkleri brief'te verilen literal hex'lerle sabitlendi (#02D3BF birincil,
// #004242 koyu metin, #A0A8B4 soluk, #E8ECF0 kenarlık, #E53935 hata, #F59E0B
// uyarı) — theme.colors.primary.main burada MAVİ (#0291EF), ATS sayfalarının
// kendi bileşenlerinde (ör. ApplicationOverviewTab) zaten #E8ECF0/#A0A8B4
// literal kullanılıyor, bu yüzden tutarlılık theme token'ı değil bu paletle.

export const BRAND = {
  primary: '#02D3BF',
  textDark: '#004242',
  muted: '#A0A8B4',
  border: '#E8ECF0',
  danger: '#E53935',
  warning: '#F59E0B',
};

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: translateY(0); }
`;

// Layout content already pads 16px; the page adds none of its own.
export const PageWrap = styled.div`
  padding: 0;
`;

export const FloatingFilters = styled.div`
  position: fixed;
  right: 20px;
  bottom: 56px;
  z-index: 120;
  display: flex;
  align-items: center;
  gap: 8px;
  background: #fff;
  border: 1px solid ${BRAND.border};
  border-radius: 10px;
  box-shadow: 0 6px 24px rgba(0, 66, 66, 0.16);
  padding: 8px 10px;

  > div {
    width: 165px;
  }

  @media (max-width: 768px) {
    left: 12px;
    right: 12px;
    justify-content: space-between;

    > div {
      flex: 1;
      width: auto;
    }
  }
`;

export const FilterIcon = styled.span`
  display: flex;
  align-items: center;
  color: ${BRAND.muted};
  flex-shrink: 0;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 16px;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(6, 1fr);
  }
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const Card = styled.div`
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 1px 4px rgba(0, 66, 66, 0.06);
  padding: 20px;
  grid-column: span ${({ $span }) => $span || 4};
  animation: ${fadeIn} 0.4s ease-out;
  animation-fill-mode: both;
  display: flex;
  flex-direction: column;
  min-height: 0;
  min-width: 0;

  @media (max-width: 1200px) {
    grid-column: span ${({ $spanMd }) => $spanMd || 6};
  }
  @media (max-width: 768px) {
    grid-column: span 1;
  }
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 14px;
`;

export const CardTitle = styled.h3`
  font-size: 15px;
  font-weight: 700;
  color: ${BRAND.textDark};
  margin: 0;
`;

export const CardMeta = styled.span`
  font-size: 12px;
  color: #6B7280;
  white-space: nowrap;
`;

export const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`;

export const ExportBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: ${BRAND.muted};
  cursor: pointer;
  padding: 0;
  transition: background 0.15s, color 0.15s;

  &:hover {
    background: rgba(2, 211, 191, 0.1);
    color: ${BRAND.primary};
  }
`;

export const EmptyState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  min-height: 120px;
  color: #9CA3AF;
  font-size: 13px;
  text-align: center;
`;

export const Skeleton = styled.div`
  flex: 1;
  min-height: ${({ $h }) => $h || '120px'};
  border-radius: 6px;
  background: linear-gradient(90deg, #F1F4F8 25%, #E9EEF4 37%, #F1F4F8 63%);
  background-size: 400% 100%;
  animation: shimmer 1.2s ease infinite;

  @keyframes shimmer {
    0% { background-position: 100% 0; }
    100% { background-position: 0 0; }
  }
`;

// --- KPI tiles -------------------------------------------------------------
export const KpiGrid = styled.div`
  grid-column: 1 / -1;
  display: grid;
  /* SPEC F3 — 6 kutu: geniş ekranda 3x2 (4 sütunda son satır yarım kalırdı). */
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

// `$clickable`: yalnız derin bağlantısı OLAN sayının imleci/vurgusu/odak halkası
// olur. Hedefi olmayan bir sayıyı tıklanabilir GÖSTERMEK, kullanıcıyı boşa tıklatan
// bir yalandır — bu yüzden stil de rol/tabIndex de koşulludur (KpiStripCard).
export const KpiTile = styled.div`
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 1px 4px rgba(0, 66, 66, 0.06);
  border-left: 4px solid ${({ $accent }) => $accent || BRAND.primary};
  padding: 16px 18px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-height: 88px;

  ${({ $clickable, $accent }) => $clickable && `
    cursor: pointer;

    @media (prefers-reduced-motion: no-preference) {
      transition: box-shadow 0.15s ease, transform 0.15s ease;
    }

    &:hover {
      box-shadow: 0 4px 14px rgba(0, 66, 66, 0.14);
      transform: translateY(-1px);
    }

    &:focus-visible {
      outline: 2px solid ${$accent || BRAND.primary};
      outline-offset: 2px;
    }
  `}
`;

export const KpiLabel = styled.div`
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #6B7280;
`;

export const KpiValue = styled.div`
  font-size: 28px;
  font-weight: 800;
  line-height: 1.1;
  color: ${BRAND.textDark};
`;

export const KpiSub = styled.div`
  font-size: 12px;
  color: #6B7280;
`;

// --- shared list/table bits --------------------------------------------------
export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
`;

export const Thead = styled.thead`
  th {
    text-align: left;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: #9CA3AF;
    padding: 0 8px 8px 0;
    border-bottom: 1px solid ${BRAND.border};
  }
  th:last-child { text-align: right; }
`;

export const Tr = styled.tr`
  ${({ $clickable }) => $clickable && 'cursor: pointer;'}
  transition: background 0.12s;

  &:hover {
    background: ${({ $clickable }) => ($clickable ? 'rgba(2, 211, 191, 0.06)' : 'transparent')};
  }
`;

export const Td = styled.td`
  padding: 9px 8px 9px 0;
  border-bottom: 1px solid #F0F2F5;
  color: ${BRAND.textDark};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 220px;

  &:last-child { text-align: right; white-space: nowrap; }
`;

export const ScrollBox = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;

  &::-webkit-scrollbar { width: 4px; }
  &::-webkit-scrollbar-thumb { background: #E5E7EB; border-radius: 4px; }
`;
